import React from 'react';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import { LayoutSingleColumn } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer.js';
import FooterContainer from '../FooterContainer/FooterContainer.js';
import SectionTeam from '../ModernLandingPage/SectionTeam/SectionTeam.js';
import StaticPage from '../PageBuilder/StaticPage.js';
import css from './AboutPage.module.css';

const AboutPageComponent = (props) => {
    const { intl } = props;

    const pageMetaProps = {
        "title": intl.formatMessage({ id: 'AP.meta.title' }),
        "description": intl.formatMessage({ id: 'General.meta.text' }),
        "schema": {
            "@context": "http://schema.org",
            "@type": "Article",
            "description": intl.formatMessage({ id: 'General.meta.text' }),
            "name": intl.formatMessage({ id: 'AP.meta.title' }),
            "headline": intl.formatMessage({ id: 'AP.meta.title' }),
        },
        "socialSharing": {
            "title": intl.formatMessage({ id: 'AP.meta.title' }),
            "description": intl.formatMessage({ id: 'General.meta.text' }),
            "images1200": null,
            "images600": null
        },
    };

    const howItWorksArray = [
        intl.formatMessage({ id: 'AP.hiw.p1' }),
        intl.formatMessage({ id: 'AP.hiw.p2' }),
        intl.formatMessage({ id: 'AP.hiw.p3' }),
        intl.formatMessage({ id: 'AP.hiw.p4' }),
        intl.formatMessage({ id: 'AP.hiw.p5' }),
        intl.formatMessage({ id: 'AP.hiw.p6' }),
        intl.formatMessage({ id: 'AP.hiw.p7' }),
    ];

    const listCircle = <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="2" cy="2" r="2" fill="#D9D9D9" />
    </svg>

    const Pointers = params => {
        const { messageprefix, countPerColumn } = params;

        return <div className={css.features}>
            <ul className={classNames(css.list, css.borderTop)}>
                {Array(countPerColumn).fill("").map((d, i) => {
                    const key = i + 1;
                    return <li key={key} className={css.listItem}>
                        {listCircle}
                        <FormattedMessage id={`${messageprefix}${key}`} />
                    </li>
                })}
            </ul>
            <ul className={classNames(css.list, css.borderTopDesktop)}>
                {Array(countPerColumn).fill("").map((d, i) => {
                    const key = i + 1 + countPerColumn;
                    return <li key={key} className={css.listItem}>
                        {listCircle}
                        <FormattedMessage id={`${messageprefix}${key}`} />
                    </li>
                })}
            </ul>
        </div>
    };

    return <StaticPage {...pageMetaProps}>
        <LayoutSingleColumn
            topbar={<TopbarContainer currentPage="AboutPage" />}
            footer={<FooterContainer />}
        >
            <div as="main" className={css.main}>
                <div className={css.hero}>
                    <h1 className={css.heroHeader}>
                        <FormattedMessage id="AP.hero.title" />
                    </h1>
                    <p className={css.heroText}>
                        <FormattedMessage id="AP.hero.subtitle" />
                    </p>
                </div>

                <div className={css.content}>
                    <div className={css.desc}>
                        <div className={css.innerDesc}>
                            <FormattedMessage id="AP.topDesc1" />
                        </div>
                        <div className={css.innerDesc}>
                            <div className={css.descTitle}>
                                <FormattedMessage id="AP.topDescTitle2" />
                            </div>
                            <FormattedMessage id="AP.topDesc2" />
                        </div>
                        <div className={css.combinedSection}>
                            <h3 className={css.combinedTitle}>
                                <FormattedMessage id="AP.topDescTitle3" />
                            </h3>
                            <div className={css.combinedPointers}>
                                <Pointers messageprefix="AP.ProblemsPoint" countPerColumn={3} />
                            </div>
                            <h3 className={css.combinedTitle}>
                                <FormattedMessage id="AP.topDescTitle4" />
                            </h3>
                            <p className={css.combinedText}>
                                <FormattedMessage id="AP.topDesc4" />
                            </p>
                        </div>
                        <div className={css.innerDescSmall}>
                            <div className={css.descTitle}>
                                <FormattedMessage id="AP.topDesc5" />
                            </div>
                        </div>
                    </div>

                    <Pointers messageprefix="AP.middlePoint" countPerColumn={4} />

                    <div className={classNames(css.howItWorks, css.howItWorksDark)}>
                        <h3 className={css.subtitle}>
                            <FormattedMessage id="AP.howItWorks" />
                        </h3>
                        <div className={css.tree}>
                            {howItWorksArray.map((item, index) => {
                                const order = index + 1;
                                return <div key={order} className={css.treeItem}>
                                    <div className={css.order}>{order}</div>
                                    <div className={css.treeText}>{item}</div>
                                </div>
                            })}
                        </div>
                    </div>

                    <div className={css.sectionTeam}>
                        <div className={css.sectionTeamInner}>
                            <SectionTeam />
                        </div>
                    </div>
                </div>
            </div>
        </LayoutSingleColumn>
    </StaticPage>
};

const AboutPage = compose(
    injectIntl,
)(AboutPageComponent);

export default AboutPage;
